import PropTypes from "prop-types";
import React from "react";
import styled from "styled-components";

const SearchContainer = styled.div`
    margin: 0 auto 40px;
    max-width: 600px;
    padding: 0 10px;
`;

const SearchInput = styled.input`
    width: 100%;
    padding: 15px 20px;
    background-color: #f4f9fb;
    border: 2px solid #c2d7e2;
    border-radius: 30px;
    font-size: 16px;
    color: var(--navy);
    outline: none;
    transition: all 0.3s ease;

    &:focus {
        border-color: var(--navy);
        background-color: #fff;
        box-shadow: 0 0 8px rgb(var(--navy-rgb) / 0.15);
    }

    &::placeholder {
        color: #88a9bc;
        font-style: italic;
    }
`;

export default function FAQSearch({ value, onChange }) {
    return (
        <SearchContainer>
            <SearchInput
                type="text"
                placeholder="Search FAQs..."
                value={value}
                onChange={onChange}
            />
        </SearchContainer>
    );
}

FAQSearch.propTypes = {
    value: PropTypes.string.isRequired,
    onChange: PropTypes.func.isRequired,
};
